const state = {
    isMobile: false,
    isTablet: false,
    sidebarMinimized: false,
    pageTitle: undefined,
    fourOhThree: false
}

const getters = {
    isMobile(state) {
        return state.isMobile
    },
    isTablet(state) {
        return state.isTablet
    },
    isSidebarMinimized(state) {
        return state.sidebarMinimized
    },
    pageTitle (state) {
        return state.pageTitle
    }
}

const actions = {
    setIsMobile ( {commit}, isMobile ) {
        commit('SET_ISMOBILE', isMobile)
    },
    setIsTablet ( {commit}, isTablet ) {
        commit('SET_ISTABLET', isTablet)
    },
    setSidebarMinimized ( {commit}, sidebarMinimized ) {
        commit('SET_SIDEBARMINIMIZED', sidebarMinimized)
    },
    setPageTitle ( {commit}, title ) {
        commit('SET_PAGETITLE', title)
    }
}

// mutations
const mutations = {
    SET_ISMOBILE(state, payload) {
        state.isMobile = payload
    },
    SET_ISTABLET(state, payload) {
        state.isTablet = payload
    },
    SET_SIDEBARMINIMIZED(state, payload) {
        state.sidebarMinimized = payload
    },
    SET_PAGETITLE(state, payload) {
        state.pageTitle = payload
    },
    SET_403(state, payload) {
        state.fourOhThree = payload
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}